import { localStorageGet } from '@Infra/LocalStorage';
import { LOCAL_STORAGE_KEYS } from '@Infra/LocalStorage/keys';

const MEMORIZED_LOGO_PATTERN = /^data:image\/(png|jpeg|webp)[;,]/;

/**
 * Synchronous: the login page renders the memorized logo on its first paint. Anything that is not an
 * image data URL of an accepted type reads as "nothing memorized".
 */
const readDisplayedLogo = (): string | null => {
	const rawLogo = localStorageGet(LOCAL_STORAGE_KEYS.DISPLAYED_LOGO);

	if (rawLogo === null || !MEMORIZED_LOGO_PATTERN.test(rawLogo)) {
		return null;
	}

	return rawLogo;
};

export default readDisplayedLogo;
